import { FC } from 'react';

import { CountChips } from '../../../../../components/CountChip';

import { DspGeoLocation } from '../../../../../types/DspGeoLocation';

interface CampaignAdGroupLocationTargetingChipsProps {
    items: DspGeoLocation[];
}

const CampaignAdGroupLocationTargetingChips: FC<CampaignAdGroupLocationTargetingChipsProps> = ({ items }) => {
    return (
        <CountChips
            items={items.map((group: DspGeoLocation) => {
                return {
                    label: group.name,
                    hideCount: true,
                };
            })}
        />
    );
};

export default CampaignAdGroupLocationTargetingChips;
